import VueTagManager from 'vue-tag-manager';

export default (app, gtmCode) => {
  app.use(VueTagManager, {
    gtmId: gtmCode,
  });
};
